module.exports = __webpack_public_path__ + "static/media/fruits_36.f17f7947.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_36.csv
// module id = 702
// module chunks = 0